import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { OnboardingFlowResponse } from '@/modules/onboarding/common/api/onboarding-flow-response';
import { OnboardingRoutes } from '@/router/routes';
import { axiosInstance } from '@/utils/axios';

/**
 * Fetches the next incomplete onboarding route for the current user.
 * Returns null if onboarding is complete.
 * @returns OnboardingRoutes enum value for next step, or null if completed
 */
export const getNotPassedOnboardingRoute = async (): Promise<OnboardingRoutes | null> => {
  const endpoint = '/api/flow-navigator/onboarding';

  const data = await withApiErrorHandler(endpoint, ApiErrorCode.ONBOARDING_FLOW_LOAD_FAILED, () =>
    axiosInstance.get(endpoint)
  );

  if ((data as OnboardingFlowResponse).completed) {
    return null;
  }

  return (data as OnboardingFlowResponse).state ?? null;
};
